import React from 'react';
import { X } from 'lucide-react';
import { Colonia } from '../../types/colonia';

interface FotoAmpliadaModalProps {
  tipo: 'aluno' | 'responsavel';
  inscricao: Colonia;
  onClose: () => void;
}

const FotoAmpliadaModal: React.FC<FotoAmpliadaModalProps> = ({ tipo, inscricao, onClose }) => {
  const foto = tipo === 'aluno' ? inscricao.fotoUrl : inscricao.fotoUrlRetirada;
  const titulo = tipo === 'aluno' ? inscricao.nomeCompleto : inscricao.nomeRetirada || 'Responsável pela retirada';

  return (
    <div className="foto-ampliada-backdrop" role="presentation" onClick={onClose}>
      <div className="foto-ampliada-stage" role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
        <button type="button" className="foto-ampliada-close" onClick={onClose} aria-label="Fechar">
          <X size={22} />
        </button>
        <div className="foto-ampliada-foto">
          {foto ? <img src={foto} alt={titulo} /> : <p className="foto-ampliada-vazia">Sem foto cadastrada.</p>}
        </div>
        {tipo === 'responsavel' && (
          <div className="foto-ampliada-dados">
            <strong>{inscricao.nomeRetirada || 'Não informado'}</strong>
            <span>{inscricao.parentescoRetirada || 'Responsável pela retirada'}</span>
            <small>Criança: {inscricao.nomeCompleto}</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default FotoAmpliadaModal;
